import React from 'react';

export default function({address, city, state, postcode}){
  return <div className="address-full">
    <div className="street">{address}</div>
    <div className="city-state-postcode">{ (city && state) && `${city}, ${state} `}{postcode}</div>
  </div>
}